import { render, staticRenderFns } from "./Stamina.vue?vue&type=template&id=5c203338&"
import script from "./Stamina.vue?vue&type=script&lang=js&"
export * from "./Stamina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports